var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgS5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 292,
    height: 192.875,
    viewBox: "0 0 292 192.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(-1036.5 -2008)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "difficulty_performing",
    "data-name": "difficulty performing",
    transform: "translate(1182.5 2119)",
    fill: "#4c2750",
    fontSize: 70,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.06em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -139.72,
    y: 0
  }, "DIFFICULTY"), /*#__PURE__*/React.createElement("tspan", {
    fontSize: 60
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -145.38,
    y: 56
  }, "PERFORMING"))), /*#__PURE__*/React.createElement("text", {
    id: "A_quarter_of_sexual_assault_survivors_have",
    "data-name": "A quarter of sexual assault survivors have",
    transform: "translate(1182.5 2032)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -116.27,
    y: 0
  }, "A QUARTER OF SEXUAL ASSAULT"), /*#__PURE__*/React.createElement("tspan", {
    x: -64.06,
    y: 22
  }, "SURVIVORS HAVE")), /*#__PURE__*/React.createElement("text", {
    id: "daily_activities_afterwards",
    "data-name": "daily activities afterwards",
    transform: "translate(1182.5 2197.875)",
    fill: "#1d1d1d",
    fontSize: 16,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -89.096,
    y: 0
  }, "daily activities afterwards")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS5);
export default __webpack_public_path__ + "static/media/s5.8a895ab894b678c988068a2b8cb0d900.svg";
export { ForwardRef as ReactComponent };